module.exports = __webpack_public_path__ + "assets/7218b2983dad448f6174577cdb5849b7.png";